import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=8fb766ea&"
import script from "./Commande.vue?vue&type=script&lang=ts&"
export * from "./Commande.vue?vue&type=script&lang=ts&"
import style0 from "./Commande.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports